import { render } from "./MarketEmailsExportImportDialog.vue?vue&type=template&id=0f1712c9&ts=true"
import script from "./MarketEmailsExportImportDialog.vue?vue&type=script&lang=ts"
export * from "./MarketEmailsExportImportDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__